import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const HandleScrollPosition = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo({ behavior: "auto", left: 0, top: 0 });
    }, 0);
  }, [pathname]);

  return null;
};

export default HandleScrollPosition;
